import * as S from './TransferChat.styles';
import React, { useCallback, useState, useRef} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { STATUS } from 'configs/constants';
import { Button } from 'ui';
import { transferAssign } from 'socket/socket';


export const TransferChat = ({
  hideModal,
  agentName,
  visitorName,
  chatId
}) => {
  const dispatch = useDispatch();
  const { partnerAgents, partnerTeamleads } = useSelector(({agents})=> agents);
  const [error, setError] = useState(false);
  const refSelect = useRef(null);

  const teammates = partnerAgents.concat(partnerTeamleads);
  let teammatesToAssign = teammates.filter((agent) => agent.name !== agentName && [STATUS.ONLINE, STATUS.INVISIBLE, STATUS.AWAY].includes(agent.status));
  teammatesToAssign = teammatesToAssign.sort((a,b) => (a.status < b.status) ? 1 : ((b.status < a.status) ? -1 : 0));



  const assignTo = useCallback((agent) => {
    transferAssign(chatId, agent._id);
    dispatch(hideModal());
  }, [hideModal, chatId, dispatch])

  const cancelAndDecline = useCallback(() => {
    transferAssign(chatId, '');
    dispatch(hideModal());
  }, [hideModal, chatId, dispatch])

  return (
    <S.TransferChatRequest>
      <S.Header>
        Transfer Request
      </S.Header>
      <S.TransferChatContainer>
        <S.ContentHeader>
          Transfer by {agentName}
        </S.ContentHeader>
        <S.VisitorInfo>
          Visitor ID: {visitorName}
        </S.VisitorInfo>
      <S.ButtonsContainer>
        <div className={`select select-default`}>
          <label>Agent</label>
          <select ref={refSelect}>
            <option value="">-- select --</option>
            {teammatesToAssign.map(agent => <option value={agent._id}>{agent.name}</option>)}
          </select>
          {error && <span className="error">select agent for transfer</span>}
        </div>
        <Button style={{height: '40px'}} onClick={() => {
          if(refSelect.current.value){
            setError(false);
            const agent = teammatesToAssign.find(i => i._id === refSelect.current.value);
            if(agent) assignTo(agent);
          }else{
            setError(true);
          }
        }}>
          Transfer
        </Button>
        <Button style={{height: '40px'}}
          color='secondary'
          onClick={() => cancelAndDecline()}
        >
          Cancel
        </Button>
      </S.ButtonsContainer>
      </S.TransferChatContainer>
    </S.TransferChatRequest>
  )
}
